<template>
<div>
<Popover
  placement="bottom-end"
  width="420"
  class="d-inline pointer"
  :visible-arrow="true"
  popper-class="popover-list bordered"
  v-model="commentsPopover">
  <div class="popover-wrapper">
    <div class="popover-title">
      Comments
      <i class="close" @click="closeCommentsPopover">
        <svgicon name="cancelblack-trans" width="12" height="12" />
      </i>
    </div>
  <div class="popover-body p-0">
    <Form :inline="true" class="form-default">
    <FormItem label="Comments" class="mb-0 form-default">
      <Input placeholder="Enter Comment" class="form-control" v-model="enteredComment"
      :disabled="!commentEditState"/>
      <div class="action-edit-block mt-10">
      <div v-if="commentEditState">
        <i class="text-grey-medium" @click="closeEditState()">
          <svgicon name="icon-close" width="8" height="8" :original="true" />
        </i>
        <i class="text-blue" @click="saveComment()">
          <svgicon name="icon-tick-sm" width="10" height="10" :original="true"  />
        </i>
      </div>
      </div>
    <div class="action-edit-block mt-10">
      <i class="" v-if="!commentEditState" @click="editState">
        <svgicon name="edit" width="12" height="12" :original="true" />
      </i>
    </div>
      </FormItem>
    </Form>
  </div>
  </div>
    <span slot="reference" class="actions pointer" @click="openCommentsPopver">
      <svgicon name="Comments" width="10" height="10" :original="true" />
    </span>
  </Popover>
</div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      enteredComment: null,
      commentEditState: false,
      commentsPopover: false,
    };
  },
  props: [
    'comment',
    'material',
    'orderNumber',
    'isEpodVisible',
  ],
  created() {
    this.enteredComment = this.comment;
  },
  methods: {
    editState() {
      this.commentEditState = true;
    },
    closeEditState() {
      this.enteredComment = this.comment;
      this.commentEditState = false;
    },
    closeCommentsPopover() {
      this.commentsPopover = false;
    },
    openCommentsPopver() {
      this.commentsPopover = true;
    },
    async saveComment() {
      const materialId = this.material.id;
      const orderNo = this.orderNumber;
      const comment = {
        comment: this.enteredComment,
      };
      const result = await this.$store.dispatch('indents/updateMaterialComment',
        { orderNo, comment, materialId },
      );
      if (result.data) {
        // update the store
        const epod = this.material.epod;
        const temp = JSON.parse(JSON.stringify({ id: this.material.id, epod }));
        temp.comment = this.enteredComment;
        delete temp.is_submited;
        // delete temp.comment;
        this.$emit('update-comment', temp);
        this.$success({ message: result.data });
        this.commentEditState = false;
        this.commentsPopover = false;
      } else {
        this.$error({ message: 'Something went wrong' });
      }
    },
  },
  watch: {
    comment(newVal) {
      this.enteredComment = newVal;
    },
  },
};
</script>
